import { OrderProgressEntity, OrderProgressRuleEntity, OrderProgressContainerEntity } from 'orders/domain/entities/order.entity'

export interface ClassificationContainerView {
    id: number
    code: string
    status: string
    statusDescription: string
    packageCount: number
}

export interface ClassificationRuleView {
    name: string
    sequence?: number | null
    containers: ClassificationContainerView[]
    totalPackages: number
}

/**
 * Adapter para órdenes de tipo Classification.
 * Transforma los datos de `/orders/:id/progress` en vistas para la UI.
 */
export class ClassificationOrderAdapter {
    /**
     * Construye las vistas de reglas desde los datos de progress.
     * Cada regla tiene containers directamente (sin chutes intermedios).
     */
    static buildRuleViews(progress: OrderProgressEntity): ClassificationRuleView[] {
        return progress.rules.map((rule) => ClassificationOrderAdapter.mapRule(rule))
    }

    private static mapRule(rule: OrderProgressRuleEntity): ClassificationRuleView {
        const containers = (rule.containers ?? []).map((c) => ClassificationOrderAdapter.mapContainer(c))

        return {
            name: rule.ruleName,
            sequence: rule.sequence ?? null,
            containers,
            totalPackages: rule.totalPackages,
        }
    }

    private static mapContainer(container: OrderProgressContainerEntity): ClassificationContainerView {
        return {
            id: container.id,
            code: container.code,
            status: container.status,
            statusDescription: container.statusDescription,
            packageCount: container.packageCount,
        }
    }
}
